import { combineReducers } from 'redux';
import { mainReducers, MainState } from '../main/main-reducer';
import { authReducers, AuthState } from '../auth/auth-reducer';
import { langReducers, LangState } from './language/lang-reducer';
import { generalReducers, GeneralState } from './general/general-reducer';
import { httpReducers, HttpState } from '@ppvrbh/merchant-frontend-core';
import { branchReducers, BranchState } from '../main/Screen/BranchManagement/redux/branch-reducer';
import { userReducers, UserState } from '../main/Screen/UserManagement/redux/user-reducer';
import { vatReducers, VatState } from '../main/Screen/VatAddress/redux/vat-reducer';
import { catReducers, CatState } from '../main/Screen/FoodCategory/redux/cat-reducer';
import { foodMenuReducers, FoodMenuState } from '../main/Screen/FoodMenu/redux/foodmenu-reducer';
import { reportReducers, ReportState } from '../main/Screen/Report/redux/report-reducer';
import { posReducers, PosState } from '../main/Screen/BranchManagement/PosManagement/redux/pos-reducer';
import { martCategoryReducers, MartCategoryState } from '../main/Screen/MartCategory/redux/martCategory-reducer';
import { martProductReducers, MartProductState } from '../main/Screen/MartProduct/redux/martProduct-reducer';
import { deviceReducers, DeviceState } from '../main/Screen/DeviceManagement/redux/device-reducer';
import { modifierItemReducers, ModifierItemState } from '../main/Screen/ModifierItem/redux/modifier-item-reducer';
import { modifierGroupReducers, ModifierGroupState } from '../main/Screen/ModifierGroup/redux/modifier-group-reducer';
import { invitationReducers, InvitationState } from '../main/Screen/components/Invitation/redux/invitation-reducer';
import { customReportReducers, CustomReportState } from '../main/Screen/CustomReport/redux/custom-report-reducer';

export const rootReducer = combineReducers<RootState>({
  main: mainReducers,
  auth: authReducers,
  http: httpReducers,
  lang: langReducers,
  general: generalReducers,
  branch: branchReducers,
  user: userReducers,
  vat: vatReducers,
  cat: catReducers,
  food: foodMenuReducers,
  report: reportReducers,
  pos: posReducers,
  martCategory: martCategoryReducers,
  martProduct: martProductReducers,
  device: deviceReducers,
  modifierItem: modifierItemReducers,
  modifierGroup: modifierGroupReducers,
  invitation: invitationReducers,
  customReport: customReportReducers,
});

export type RootState = {
  main: MainState,
  auth: AuthState,
  http: HttpState,
  lang: LangState,
  general: GeneralState,
  branch: BranchState,
  user: UserState,
  vat: VatState,
  cat: CatState,
  food: FoodMenuState,
  report: ReportState,
  pos: PosState,
  martCategory: MartCategoryState,
  martProduct: MartProductState,
  device: DeviceState,
  modifierItem: ModifierItemState,
  modifierGroup: ModifierGroupState,
  invitation: InvitationState,
  customReport: CustomReportState,
};
